import { ensureArray } from '../array-helpers/ensure-array';
import { getIndexInStore } from './get-index-in-store';

/**
 * Replaces the given object(s) from the datastore and notifies the observable
 * @param dataStore The data store
 * @param newObjects The object(s) to compare with
 * @param filterByProperties The properties used to find the object in the store
 */
export function updateStore<T>(dataStore: T[], newObjects: T | T[], filterByProperties: keyof T | (keyof T)[]) {
	const store = [...dataStore];

	// Always work with an array
	const filterProperties = ensureArray(filterByProperties);

	// Add / Replace the objects
	ensureArray(newObjects).forEach(newObject => {
		const oldIndex = getIndexInStore(store, newObject, filterProperties);
		oldIndex > -1 ? store.splice(oldIndex, 1, newObject) : store.push(newObject);
	});

	return store;
}
